/**
 * Returns the list of empresa IDs the current user is allowed to see.
 *
 * Source: GET /v1/auth/me — the backend validates the JWT and returns the
 * empresas derived from the user's App Roles.
 *
 * WHY NOT idTokenClaims.roles:
 *   App Roles are defined on the *backend* App Registration (98601328).
 *   MSAL's accounts[0].idTokenClaims is the ID token issued for the
 *   *frontend* App Registration (6327209b).  Azure AD only puts App Roles
 *   in the token of the app they are defined on, so idTokenClaims.roles
 *   is always undefined in the frontend.
 */
import { useQuery } from '@tanstack/react-query'
import { authApi } from '@/services/api'

export function useAllowedEmpresas(): string[] {
  const { data } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.getMe,
    staleTime: 60 * 60 * 1000,  // 1 h — roles don't change mid-session
    gcTime:    60 * 60 * 1000,
    retry: false,                // don't spam the backend on auth errors
  })
  return data?.empresas ?? []
}
